
(()=>{
const root=document.getElementById('bh-kit-main');
if(!root||root.dataset.initialized==='true')return;
root.dataset.initialized='true';
const photos=Array.from(root.querySelectorAll('[data-bh-photo]'));
const image=root.querySelector('[data-bh-photo-wrap] img');
const caption=root.querySelector('[data-bh-caption]');
const rail=root.querySelector('.bh-gallery');
const dialog=root.querySelector('dialog');
const viewer=root.querySelector('[data-bh-viewer-image]');
const sticky=root.querySelector('[data-bh-sticky]');
let current=photos.find(p=>!p.hidden),lastSwipe=0;
const visible=()=>photos.filter(p=>!p.hidden);
function counter(){
const items=visible(),n=items.indexOf(current)+1;
root.querySelectorAll('[data-bh-count],[data-bh-viewer-count]').forEach(el=>el.textContent=n+' / '+items.length);
root.querySelectorAll('[data-bh-prev],[data-bh-next]').forEach(el=>el.disabled=items.length<2);
}
function syncViewer(){
if(!current)return;
viewer.src=current.dataset.src;viewer.srcset=current.dataset.srcset;viewer.sizes='(min-width:1080px) 1020px, calc(100vw - 60px)';viewer.alt=current.dataset.caption;
root.querySelector('[data-bh-viewer-caption]').textContent=current.dataset.caption;
}
function showPhoto(button){
if(!image||!button)return;
current=button;image.src=button.dataset.src;image.srcset=button.dataset.srcset;image.alt=button.dataset.caption;image.dataset.bhPhotoKind=button.dataset.kind;
image.width=Number(button.dataset.width);image.height=Number(button.dataset.height);
caption.textContent=button.dataset.caption;
photos.forEach(p=>p.setAttribute('aria-pressed',String(p===button)));
counter();if(dialog.open)syncViewer();
const b=button.getBoundingClientRect(),r=rail.getBoundingClientRect();
if(b.left<r.left)rail.scrollLeft-=r.left-b.left;
if(b.right>r.right)rail.scrollLeft+=b.right-r.right;
}
function step(delta){const items=visible();showPhoto(items[(items.indexOf(current)+delta+items.length)%items.length]);}
photos.forEach(button=>button.addEventListener('click',()=>showPhoto(button)));
root.querySelectorAll('[data-bh-prev]').forEach(b=>b.addEventListener('click',()=>step(-1)));
root.querySelectorAll('[data-bh-next]').forEach(b=>b.addEventListener('click',()=>step(1)));
function openViewer(){if(Date.now()-lastSwipe<400)return;syncViewer();if(!dialog.open)dialog.showModal();sticky.hidden=true;}
root.querySelectorAll('[data-bh-open]').forEach(b=>b.addEventListener('click',openViewer));
root.querySelector('[data-bh-go-plan]')?.addEventListener('click',()=>{showPhoto(photos.find(p=>p.dataset.kind==='plan'));openViewer();});
root.querySelector('[data-bh-close]').addEventListener('click',()=>dialog.close());
dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
root.addEventListener('keydown',e=>{if(!dialog.open&&!photos.includes(document.activeElement))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();step(e.key==='ArrowRight'?1:-1);}});
let start=null;
const photoWrap=root.querySelector('[data-bh-photo-wrap]');
photoWrap.addEventListener('touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
photoWrap.addEventListener('touchend',e=>{if(!start||!e.changedTouches[0])return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){lastSwipe=Date.now();step(dx<0?1:-1);}},{passive:true});
root.querySelectorAll('[data-bh-variant]').forEach(button=>button.addEventListener('click',()=>{
const material=button.dataset.bhVariant,mesh=material==='malla';
const amount=root.querySelector('[data-bc-price-amount]'),scope=root.querySelector('[data-bc-price-scope]');
if(amount)amount.textContent=mesh?'Por cotizar':'$68,000 MXN';
if(scope)scope.textContent=mesh?"El precio de una caseta no se aplica automáticamente a la opción de malla sombra. Esa configuración se cotiza por separado; la foto de la regadera ilustra únicamente el cerramiento.":"Referencia para una caseta de baño de campo. WC, lavabo, regadera y equipos se especifican en la cotización. No es el precio de dos casetas ni de la alternativa de malla sombra.";
photos.forEach(p=>p.hidden=p.dataset.material!==material);
root.querySelectorAll('[data-bh-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
root.querySelector('[data-bh-fact-variant]').textContent=mesh?'Malla sombra':'Lámina';
root.querySelector('[data-bh-form-model]').value=mesh?'Baño de campo · malla sombra':'Baño de campo · lámina';
root.querySelector('[data-bh-variant-copy]').textContent=mesh?'La fotografía muestra una regadera real con malla sombra, como referencia del cerramiento. No es el kit completo. Privacidad, cubierta y protección de lluvia se especifican; la malla no es impermeable.':'Lámina: cerramiento opaco. Ventilación, puerta, cubierta y equipos se especifican con el modelo que coticemos.';
showPhoto(visible()[0]);
}));
const inView=new Map();
function updateSticky(){sticky.hidden=dialog.open||Array.from(inView.values()).some(Boolean)||inView.size<3;}
if('IntersectionObserver'in window){const io=new IntersectionObserver(entries=>{if(!root.isConnected){io.disconnect();return;}entries.forEach(e=>inView.set(e.target,e.isIntersecting));updateSticky();});[root.querySelector('[data-bh-hero-cta]'),root.querySelector('.bh-contact'),root.querySelector('[data-bh-related]')].forEach(el=>io.observe(el));}
dialog.addEventListener('close',updateSticky);

counter();
})();
